import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AccountType } from '../models/user.model';

export const dashboardGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const user = authService.currentUser();

  if (!user) {
    return router.createUrlTree(['/auth/login']);
  }

  switch (user.accountType) {
    case AccountType.SUPER_ADMIN:
      return router.createUrlTree(['/super-admin']);
    case AccountType.COUNCIL:
      return router.createUrlTree(['/council']);
    case AccountType.CRC:
      return router.createUrlTree(['/crc']);
    default:
      return router.createUrlTree(['/auth/login']);
  }
};
